import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves box number data.
 * @returns - A promise that resolves to the box number data.
 */
export const useFetchBoxNumbers = (special) => {
  const memoizedFetchBoxNumbers = useMemo(
    () => async (assignmentDate, pulloutDivision) => {
      const apiDate = format(assignmentDate, "dd-MMM-yyyy");
      return apiGet(
        `/boxNumbers/${apiDate}/${pulloutDivision}/${special}`,
        "fetching Box Numbers"
      );
    },
    [special]
  );

  return memoizedFetchBoxNumbers;
};
